import { Component, Input, OnInit,ChangeDetectorRef } from '@angular/core'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'
import { CourbeService, DialogService, StateService } from '../../../../../services'
import { ConfirmComponent } from "../../../../partials/layout/dialogs/confirm-dialog/confirm.component"
import { CourrierDialog } from '../../../../partials/layout/dialogs/courrier-dialog/courrier-dialog.component'
import { SuiviListing } from '../../../../partials/content/listing/suivi-listing/suivi-listing.component'
import { FormulaireSuiviListing } from '../../../../partials/content/listing/formulaire-suivi-listing/formulaire-suivi-listing.component'
import { InstructionListing } from '../../../../partials/content/listing/instruction-listing/instruction-listing.component'
import { of,Observable, Subject,  } from 'rxjs'
import * as moment from 'moment'

const KEY = "dossier-page-courbe"

@Component({
    selector: 'atyl-dossier-page-courbe',
    templateUrl: './dossier-page-courbe.component.html',
    styleUrls: ['./dossier-page-courbe.component.scss']
})
@Stringable({
    path: "views/pages/recherche/tabs/courbe",
    key: KEY,
})
export class DossierPageCourbeComponent implements OnInit {
    @StringableValues(KEY) strings: any
    @Input() eventLoad: Observable<boolean>;
    loading: boolean = false;
	
	
     @Input() dossier: any;
     
    courbes:any[]=[];
    selectCourbeIndex:number=0;
   
    eventsLoadingOneCourbeSubject: Subject<boolean> = new Subject<boolean>();
   
    enventsArray: Subject<boolean>[]= [];
   
    beginInput: any;
    endInput: any;
    
    filters:any;
	
	private eventsSubscription: any
	sub:any;
	
    constructor(
        private courbeService: CourbeService,
        private stateService: StateService,
        private dialogService: DialogService,
        private changeDetectorRef: ChangeDetectorRef,
    ) { }

    ngOnInit() {

        this.filters={
			begin: this.beginInput,
			end: this.endInput
		}

    
        
        this.eventsSubscription=this.eventLoad.subscribe((loading:boolean) => {
			 if (!loading) {
				if(this.sub!=undefined)
					this.sub.unsubscribe(); 
			 }
			 else {
		         this.loading=loading;
		         
		         this.sub=this.courbeService.list(this.dossier.ID).subscribe(
					(res: JSONRpcResponse) => {
						
						if (res.result) {
							 
							this.courbes=res.result;
							
							for(let i=0;i<this.courbes.length;i++) 
							   this.enventsArray.push(new Subject<boolean>());
							
							/*if (this.courbes.length>0)
							  this.changeCourbe(this.selectCourbeIndex,this.courbes[this.selectCourbeIndex]);
							  */
						}	
						this.loading=false;
						this.changeDetectorRef.detectChanges();
					}
				);
			}	
	         
		});
    }
	
	ngOnDestroy() {
	       this.eventsSubscription.unsubscribe();
		if(this.sub!=undefined)
			this.sub.unsubscribe();
	}
	   
    changeCourbe(index:number,courbe:any) {
	        console.log("changeCourbe",index,courbe);
			this.enventsArray[index].next(true);
			//this.selectCourbeIndex=index;
			//this.eventsLoadingOneCourbeSubject.next(true);
		//	this.setFilters();
	}

     setFilters() {
		this.filters={
				begin: this.beginInput,
				end: this.endInput
			}
		
		this.changeDetectorRef.detectChanges();
	}

	updateBeginDate(event: any) {
		
		
		this.setFilters();

	}
    updateEndDate(event: any) {
		
	
		this.setFilters();
	}
	
	showData(event: any) {
		
		this.enventsArray[this.selectCourbeIndex].next(true);
	}

}




